import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicReset({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M8.35 2a5.75 5.75 0 010 11.5 6.3 6.3 0 01-3.68-1.41.5.5 0 01.01-.7l.35-.34a.5.5 0 01.65-.04c.87.66 1.76.99 2.67.99a4.25 4.25 0 10-3.87-6h1.77c.28 0 .5.22.5.5V7a.5.5 0 01-.5.5H2.5A.5.5 0 012 7V3.25c0-.28.22-.5.5-.5H3c.28 0 .5.22.5.5v1.4A5.75 5.75 0 018.35 2z" />
    </svg>
  );
}

SvgBasicReset.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicReset.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicReset svgRef={ref} {...props} />);
export default ForwardRef;
